import React from 'react';
import { findIndex } from 'lodash';
import Input from '../../../../components/input/Input';
import TableColumnImg from '../../../../components/table/TableColumnImg';
import { setDateFormat } from '../../../../lib/moment';
import SwitchForm from '../../../../components/form/SwitchForm';
import Button from '../../../../components/Button';
import {
  BRAND_EXPOSURE_LIST_STATUS,
  BRAND_EXPOSURE_STATUS_INDEX_JSON,
  MAXIMUM_NUMBER_OF_TIER_ORDER_TEXT,
} from '../../../../constants/service/app/brandConstants';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import OpenBrandDetail from '../../../../components/link/OpenBrandDetail';

/**
 * react-table v6 Cell 안정화를 위해 모듈 레벨에서 정의
 */
const ExposureStatusCell = (row) => {
  const { changeExposureStatus } = row.column;
  return (
    <SwitchForm
      className="brand-exposure-status-toggle"
      checked={BRAND_EXPOSURE_STATUS_INDEX_JSON.ACTIVE === row.value}
      disabled={row.original.listStatus === BRAND_EXPOSURE_LIST_STATUS.DELETED}
      onChange={(value) => changeExposureStatus(row.index, value)}
    />
  );
};

const OrderNumberCell = (row) => {
  const { newList, setData, changeNumberOnBrandTierList, scrollToBrandElement } = row.column;
  return (
    <div name={`no_${row.value}`} onClick={(e) => e.preventDefault()}>
      <Input
        type="number"
        size="large"
        maxLength={MAXIMUM_NUMBER_OF_TIER_ORDER_TEXT}
        value={row.value}
        disabled={row.original.listStatus === BRAND_EXPOSURE_LIST_STATUS.DELETED}
        onBlur={() => {
          if (row.index === row.value - 1) return;

          /**
           *  스크롤 될 인덱스
           */
          let scrollIndex = 0;

          /**
           *  스크롤 최대 최솟값 설정
           */
          if (newList.length - 1 < row.value) {
            /**
             *  최대값으로 배열의 마지막 인덱스
             */
            scrollIndex = newList.length;
          } else if (row.value <= 0) {
            /**
             *  최솟값으로 배열의 마지막 인덱스
             */
            scrollIndex = 1;
          } else {
            /**
             *  순서를 변경하려는 곳의 인덱스를 구한다.
             */
            scrollIndex = findIndex(newList, (item, index) => index !== row.index && item.no === row.value) + 1;
          }

          /**
           *  순서 변경
           */
          changeNumberOnBrandTierList(row.index, scrollIndex - 1);

          /**
           *  순서변경된 곳으로 스크롤 이동
           */
          setTimeout(() => scrollToBrandElement(scrollIndex), 0);
        }}
        onChange={(value) => {
          setData({
            path: ['brandExposureList', 'newList', row.index, 'no'],
            value: Number(value),
          });
        }}
      />
    </div>
  );
};

/**
 *  앱에서 노출되는 브랜드 목록
 */
const columns = (data) => {
  const {
    newList,
    setData,
    scrollToBrandElement,
    changeExposureStatus,
    changeNumberOnBrandTierList,
    deleteBrandExposureItem,
  } = data;
  return [
    {
      accessor: 'url',
      Header: '이미지',
      Cell: (row) => <TableColumnImg url={row.value} />,
    },
    {
      accessor: 'storeName',
      Header: '브랜드 명',
      Cell: (row) => <OpenBrandDetail text={`${row.value}(${row.original.storeId})`} storeId={row.original.storeId} />,
    },
    {
      accessor: 'status',
      Header: '노출여부',
      maxWidth: 60,
      changeExposureStatus,
      Cell: ExposureStatusCell,
    },
    {
      accessor: 'confirmDate',
      Header: '입점일자',
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_DASH_FORMAT),
    },
    {
      accessor: 'uploadCount',
      Header: '총 제품 수',
      maxWidth: 80,
    },
    {
      accessor: 'saleCount',
      Header: '판매중인 제품 수',
    },
    {
      accessor: 'likeCount',
      Header: '찜 수',
      maxWidth: 60,
    },
    {
      accessor: 'memo',
      Header: '메모',
    },
    {
      accessor: 'tier',
      Header: '브랜드 티어',
      Cell: (row) => (row.value ? `${row.value}티어 ${row.original.tierNo}번` : null),
    },
    {
      accessor: 'no',
      Header: '순서',
      maxWidth: 80,
      newList,
      setData,
      changeNumberOnBrandTierList,
      scrollToBrandElement,
      Cell: OrderNumberCell,
    },
    {
      Header: '삭제',
      Cell: (row) => (
        <Button
          isRadius
          text={row.original.listStatus === BRAND_EXPOSURE_LIST_STATUS.DELETED ? '삭제취소' : '삭제'}
          color={row.original.listStatus === 'deleted' ? 'gray' : 'red'}
          onClick={() => {
            deleteBrandExposureItem(row.original.tier, row.original.storeId);
          }}
        />
      ),
    },
  ];
};

export default columns;
